import { Injectable } from '@angular/core'
import { environment } from '@env/environment'
import { HttpClient } from '@angular/common/http'
import { User } from '../models/user.model'
import { BehaviorSubject, Observable } from 'rxjs'
import { map } from 'rxjs/operators'

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private readonly USERS = 'users'

  private userSubject: BehaviorSubject<User> = new BehaviorSubject(null)
  public user: Observable<User>
  get currentUser(): User {
    return this.userSubject.getValue()
  }

  private statusSubject: BehaviorSubject<'connection' | 'userinfo'> =
    new BehaviorSubject(null)

  public status: Observable<'connection' | 'userinfo'>

  /** Returns whether the current user is still valid */
  get hasValidUser(): boolean {
    return !!this.currentUser
  }

  constructor(private http: HttpClient) {
    this.user = this.userSubject.asObservable()
    this.status = this.statusSubject.asObservable()
  }

  public getUser(): Observable<User> {
    return this.http.get<User>(`${environment.apiUrl}${this.USERS}/me`, { withCredentials: true }).pipe(
      map((user: User) => {
        if (user) {
          const newUser = new User(user)
          this.userSubject.next(newUser)
          return newUser
        }
      })
    )
  }
}
